import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from 'components/ProtectedRoute/ProtectedRoute';

interface RouteConfig {
    path: string;
    component: React.ComponentType;
    protected?: boolean;
    label?: string;
}

const routerFactory = (routes: RouteConfig[]): React.ReactNode => {
    return routes.map((route) => {
        const Component = route.component;

        // Wrap protected routes with ProtectedRoute component
        const element = route.protected ? (
            <ProtectedRoute>
                <Component />
            </ProtectedRoute>
        ) : (
            <Component />
        );

        return <Route key={route.path} path={route.path} element={element} />;
    });
};

export default routerFactory;

